<template>
  <div class="review-star-rating">
    <label
      v-for="rating in 5"
      :key="rating"
      class="cursor-pointer text-2xl"
      data-testid="add-review-rating-star"
      @mouseover="mouseOverHandle(rating)"
      @mouseleave="hoverRating = 0"
    >
      <input
        type="radio"
        :value="rating"
        :name="name"
        class="hidden"
        :checked="selectedRating === rating"
        @change="onSelect(rating)"
      >
      <ReviewStar
        :rating="rating"
        :selected-rating="selectedRating"
        :hover-rating="hoverRating"
      />
    </label>
    <div
      v-if="!valid && errorMessage"
      class="sf-input__error-message"
    >
      <div
        data-testid="add-review-rating-error"
      >
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'ReviewStarRating',

  props: {
    modelValue: {
      type: Number as PropType<number | undefined>,
      default: undefined,
    },
    required: {
      type: Boolean,
      default: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {

    const resolvedValue = computed(() => props.modelValue);

    const selectedRating = ref(resolvedValue.value);
    const hoverRating = ref(resolvedValue.value);

    watch(resolvedValue, (nextValue) => {

      selectedRating.value = nextValue;
      hoverRating.value = nextValue;

    });

    const onSelect = (rating: number) => {

      selectedRating.value = rating;
      emit('update:modelValue', rating);

    };

    const mouseOverHandle = (rating:number) => {

      hoverRating.value = rating;
    
    };

    return {
      selectedRating,
      hoverRating,
      mouseOverHandle,
      onSelect,
    };
  
  },
});

</script>
